/**
 * How the import speaks about its own state.
 *
 * An import is an *attempt*: you upload a statement, work through it, and quite
 * possibly stop halfway to ask a colleague what a payment was. That pause is a
 * normal state, not an error, which is why an attempt stays in the list until
 * you finish it rather than expiring or being cleaned up.
 */

// A whole attempt. Mirrors constants.StagingBatchStatus on the backend, which
// recompute_batch_status derives from the rows -- an attempt becomes
// "Zaključeno" on its own once nothing is left to review.
export const ATTEMPT_STATUS_META = {
  OPEN: { color: 'blue', label: 'V pregledu' },
  PARTIALLY_PROMOTED: { color: 'gold', label: 'Delno shranjeno' },
  PROMOTED: { color: 'green', label: 'Zaključeno' },
  DISCARDED: { color: 'default', label: 'Zavrženo' },
};

// A single line within an attempt. Mirrors constants.StagedTransactionStatus.
export const ROW_STATUS_META = {
  PENDING: { color: 'blue', label: 'Za pregled' },
  DUPLICATE: { color: 'orange', label: 'Podvojeno' },
  ERROR: { color: 'red', label: 'Napaka' },
  PROMOTED: { color: 'green', label: 'Shranjeno' },
  DISCARDED: { color: 'default', label: 'Zavrženo' },
};

export const PAGE_TITLE = 'Uvoz iz XLSX';
export const PARENT_TITLE = 'Orodja';
